<section class="container-fluid clearfix p-0">
  <app-dashboard-stack [data]="data" [navCtrlr]="navCtrlr" [indicators]="local_indicators"></app-dashboard-stack>
</section>
